import { memo, FunctionComponent } from 'react'

import NavigationButtonPrev from './NavigationButtonPrev'
import NavigationButtonNext from './NavigationButtonNext'
import { NavigationOptions } from 'swiper/types'

export interface SwiperNavigationProps extends NavigationOptions {
  prevElRef: React.Ref<HTMLDivElement>
  nextElRef: React.Ref<HTMLDivElement>
  onPrevButtonClick?: React.MouseEventHandler<HTMLDivElement>
  onNextButtonClick?: React.MouseEventHandler<HTMLDivElement>
}

export interface NavigationButtonProps {
  onClick?: React.MouseEventHandler<HTMLDivElement>
  ref: React.Ref<HTMLDivElement>
}

const SwiperNavigation: FunctionComponent<SwiperNavigationProps> = ({
  nextElRef,
  prevElRef,
  onPrevButtonClick,
  onNextButtonClick,
}) => {
  return (
    <>
      <NavigationButtonPrev ref={prevElRef} onClick={onPrevButtonClick} />
      <NavigationButtonNext ref={nextElRef} onClick={onNextButtonClick} />
    </>
  )
}

export default memo(SwiperNavigation)
